import BaseResource from '@i22/frontend-cms-utils/models/resource'

export class Resource extends BaseResource {
  static Models = { Resource }

  static addModel (model) {
    Resource.Models[model.entity] = model
  }

  static types () {
    return Resource.Models
  }

  static getTypeModel (name) {
    return Resource.types()[name] || Resource
  }

  get readableName () {
    let title = this.columns.title || this.columns.meta_title || this.name
    if (typeof title === 'object') {
      const language = this.language
      title = language ? title[language] : title
    }
    return title
  }

  get searchCategory () {
    if (!this.columns.searchCategory && this.parentResource) {
      return this.parentResource.searchCategory
    }
    return this.columns.searchCategory
  }

  getCountry () {
    if (!this.columns.country && this.parentResource) {
      return this.parentResource.getCountry()
    }
    return this
  }

  get country () {
    const country = this.getCountry()
    return country && country.columns && country.columns.country ? country.columns.country : null
  }

  getLanguage () {
    if (!this.columns.language && this.parentResource) {
      return this.parentResource.getLanguage()
    }
    return this
  }

  get language () {
    const language = this.getLanguage()
    return language && language.columns && language.columns.language ? language.columns.language : null
  }
}

export default Resource
